import { SettingMessages, TranslationSettingMessages } from "../interfaces/settingMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationSettingMessages = {
  [SettingMessages.settingTitlePage]: "Ajustes",
  [SettingMessages.settingDeleteOptionTitle]: "Borrar cuenta",
  [SettingMessages.settingChangePasswordOptionTitle]: "Cambiar contraseña",
  [SettingMessages.settingLoginVerificationFailed]: `Error al verificar la contraseña, verifique su contraseña actual e
    inténtelo de nuevo`,
  [SettingMessages.settingParamsTitle]: "Parámetros",
  [SettingMessages.settingColorsTitle]: "Colores",
  [SettingMessages.settingIconsTitle]: "Iconos",
  [SettingMessages.settingParamsMinDaysDescription]: "Días mínimos para solicitar programación",
  [SettingMessages.settingParamsDaysLabel]: "Días",
  [SettingMessages.settingColorsPrimary]: "Color primario",
  [SettingMessages.settingColorsSecondary]: "Color secundario",
  [SettingMessages.settingColorsTertiary]: "Color terciario",
  [SettingMessages.settingsColorsDisable]: "Color de inactividad",
  [SettingMessages.settingsColorsLoginBackground]: "Color de fondo de inicio de sesión",
  [SettingMessages.settingEnvironmentTitle]: "Ambiente",
  [SettingMessages.settingParamsSuccessUpdate]: "Parámetros actualizados con éxito.",
  [SettingMessages.settingParamsNoChange]: "Ningún parámetro ha cambiado.",
  [SettingMessages.settingNotificationReload]: "Al cambiar el aspecto, la página se recargará para su actualización.",
  [SettingMessages.settingColorsNoChange]: "Ningún color ha cambiado.",
  [SettingMessages.settingIconsNoChange]: "Ningún icono ha cambiado."
};
